<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <app-check [color]="color" [value]="themeOptions.options().animation.animateScale" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-theme-option>